<div id="biens-comparables-vendus-form" class="px-4">
  <div class="mb-4">
    <div class="mb-3 fw-bold">Type d'affichage</div>
    <div class="d-flex ms-4 fs-6">
      <span
        [ngClass]="{ 'text-black-50': newReferences.isDisplayModeDetailled }"
      >
        Liste simple
      </span>
      <p-radio
        title="Mode d'affichage"
        class="ms-2"
        [checked]="newReferences.isDisplayModeDetailled"
        [alwaysActivated]="true"
        (switched)="isDisplayModeDetailledChanged($event)"
      ></p-radio>
      <span
        [ngClass]="{ 'text-black-50': !newReferences.isDisplayModeDetailled }"
      >
        Liste détaillée
      </span>
    </div>
  </div>

  <div class="mb-4">
    <div class="mb-3 fw-bold">Confidentialité des données</div>
    <div class="d-flex ms-4 fs-6">
      <span [ngClass]="{ 'text-black-50': newReferences.isConfidential }">
        Exemplaire office
      </span>
      <p-radio
        title="Confidentialité des données"
        class="ms-2"
        [checked]="newReferences.isConfidential"
        [alwaysActivated]="true"
        (switched)="isConfidentialChanged($event)"
      ></p-radio>
      <span [ngClass]="{ 'text-black-50': !newReferences.isConfidential }">
        Exemplaire client
      </span>
    </div>
  </div>

  <p class="text-secondary">
    La remise d’une liste de références à votre client exige l’anonymisation des
    données, à savoir le retrait du numéro dans la voie et de la parcelle
    cadastrale.
  </p>

  <div class="mb-4" *ngIf="reportType !== 'automatic_evaluation'">
    <div class="mb-3 fw-bold">Références à afficher</div>
    <div class="d-flex ms-4 fs-6">
      <span [ngClass]="{ 'text-black-50': newReferences.isSelection }">
        Toute les références achetées ({{ references.purchasedCount }})
      </span>
      <p-radio
        title="Références à afficher"
        class="ms-2"
        [checked]="newReferences.isSelection"
        [alwaysActivated]="true"
        (switched)="isSelectionChanged($event)"
      ></p-radio>
      <span [ngClass]="{ 'text-black-50': !newReferences.isSelection }">
        Références sélectionnées ({{ references.selectedCount }})
      </span>
    </div>
  </div>
</div>
